import { Alert, Paper, Slide, Typography } from "@mui/material";
import DataCollectionBrands from "../../../components/DataCollection/Brands/DataCollectionBrands";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../features/userSlice";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";
import { useDispatch } from "react-redux";
import { setIsSuccess } from "../../../features/dataCollectionBrandsSlice";
import { useEffect } from "react";
const DataCollectionBrandsScreen = () => {
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasViewDataCollectionBrandsPermission = CheckPermissions(
    response?.data?.products?.data_collection,
    "brands",
    "view_brands"
  );
  const { isSuccess, resWorkflowName } = useSelector(
    (state: any) => state.dataCollectionBrands
  );

  // useEffect(() => {
  //   if (isSuccess) {
  //     const timeout = setTimeout(() => {
  //       dispatch(setIsSuccess(false));
  //     }, 10000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [isSuccess, dispatch]);

  useEffect(() => {
    dispatch(setIsSuccess(false));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    dispatch(setIsSuccess(false));
  };

  const handleProcessLogsNavigation = () => {
    const today = new Date().toISOString().split("T")[0];
    const query = new URLSearchParams({
      start_date: today,
      end_date: today,
      workflow_name: resWorkflowName,
      page: "0",
    });
    window.open(
      `/data_collection/monitoring/process_logs?${query.toString()}`,
      "_blank"
    );
  };

  return (
    <>
      {hasViewDataCollectionBrandsPermission ? (
        <>
          <Slide
            direction="left"
            in={isSuccess}
            mountOnEnter
            unmountOnExit
            timeout={200}
          >
            <div>
              <Alert
                severity="success"
                onClose={handleClose}
                sx={{
                  mb: 2,
                  border: "1px solid rgba(0, 128, 0, 0.3)",
                  backgroundColor: "rgba(240, 255, 240, 0.9)",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "17px",
                    fontWeight: "500",
                    marginBottom: "4px",
                  }}
                >
                  The process has been launched successfully!
                </Typography>
                To monitor the workflow results{" "}
                <span
                  onClick={handleProcessLogsNavigation}
                  style={{
                    textDecoration: "underline",
                    color: "#9C27B0",
                  }}
                  data-tracker="366"
                >
                  CLICK HERE
                </span>{" "}
                (It may take a few minutes for the logs to appear in the Process
                Log Table.)
              </Alert>
            </div>
          </Slide>

          <Paper sx={{ padding: "8px 16px" }}>
            <DataCollectionBrands />
          </Paper>
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default DataCollectionBrandsScreen;
